import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import LogicContext from "../../Context/LogicContext";
import { accountService } from "../../services/accountService";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import moment from "moment";
import { debounce } from 'lodash';
import GeneralCustomerSearch from "../../generals/GeneralCustomerSearch";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import { SetPaymentMadeAtom, GetPaymentReceiveAtom } from "../../store/paymentReceivedAtom";


const AddPaymentReceivePage = () => {
  const navigate = useNavigate();
    const paymentAtom = GetPaymentReceiveAtom();
  const logicContext = useContext(LogicContext);
    const myPromiseModal = createModal(GeneralModal);
      const setPaymentMadeAtom = SetPaymentMadeAtom();
    

 

    const [selCustomer, setSelCustomer] = useState(null);
  const { register, handleSubmit, getValues,setValue,   control,  formState: { errors } } = useForm({
    defaultValues: {
      customer_id: "",
      payment_date: moment(new Date(), "DD-MM-YYYY").format("YYYY-MM-DD"),
      payment_method: "",
      payment_refno: "",
      amount: "",
      remark: "",
    },
  });

    useEffect(()=> {
      if (!paymentAtom.deposit_info?.length) {
        getPaymentListApi();
      }
  
    },[paymentAtom.deposit_info?.length]);




   const getPaymentListApi = async () => {
      try {
        const response = await accountService.getPaymentReceiveList();
        if (response?.data?.deposit_info?.length) {
          setPaymentMadeAtom(response.data);
      
        }
      } catch (error) {
        // logicContext.showToast("connection error getting invoice data", "error");
      }
    };


    const debouncedOnCustomerSelect = useCallback(
      debounce((customer) => {
        setSelCustomer(customer);
        setValue("customer_id", customer.Customer_Id, { shouldValidate: true });
      }, 300),
      [setValue]
    );
  
    const onCustomerSelect = useCallback((customer) => {
      debouncedOnCustomerSelect(customer);
    }, [debouncedOnCustomerSelect]);
  
    // const onProductSelect = useCallback((feature) => {
    //   setProductFeature(feature);
    // }, []);

  const onSubmit = async (data) => {
    const formData = getValues();
    try {
      const res = await myPromiseModal({
        title: "Confirmation",
        body: `Save Payment Records`,
        showInput: false,
      });
      if (res.decision === false) {
        return
      }

      const response = await accountService.submitPaymentReceived({...formData, option:1});
      // logicContext.showToast("Payment success", "success");
      // if (response?.data) {
        const cleanResponse =  logicContext.httpResponseManager(response.data?.[0] || response.data?.result_status?.[0]);
        logicContext.showToast(cleanResponse?.message_text, 'success');
        sessionStorage.setItem("reloadPage", "true");
          navigate(-1);
      //   } 
    } catch (error) {
      // logicContext.showToast("Error creating payment record", "error");
    }
  };


  const depositMethods = paymentAtom?.deposit_method?.filter(m => m.Name !== 'All');

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full w-full h-full bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6 text-left">Add Payment Record</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-2 gap-4">
        
          {/* Customer Name */}
          <div>
          <label className="text-sm font-medium text-red-600 mb-1">Customer Name</label>
          <Controller
            name="customer_id"
            control={control}
            rules={{ 
              required: "Customer selection is required",
              validate: (value) => value !== 0 || "Please select a valid customer"
            }}
            render={({ field }) => (
              <GeneralCustomerSearch 
                // defaultVal={invoiceToEdit?.Customer_Full_Name} 
                onCustomerSelect={onCustomerSelect}
              />
            )}
          />
          {errors.Customer_Id && (
            <p className="mt-1 text-sm text-red-600">{errors.customer_id.message}</p>
          )}
          {selCustomer && (
            <div className="mt-3 p-3 border border-gray-300 rounded-md bg-gray-50">
              <p className="font-semibold">Customer: {selCustomer?.Name}</p>
              <p className="font-semibold">ID: {selCustomer?.Customer_Id}</p>
            </div>
          )}
        </div>
         
          <div>
            <label htmlFor="payment_date" className=" text-sm font-medium text-gray-700">
              Payment Date
            </label>
            <input
              type="date"
              id="payment_date"
              {...register("payment_date", { required: "Payment date is required" })}
              className="mt-1  w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
            />
            {errors.payment_date && (
              <p className="mt-1 text-sm text-red-600">{errors.payment_date.message}</p>
            )}
          </div>


        


          <div>
            <label htmlFor="payment_method" className=" text-sm font-medium text-gray-700">
              Payment Method
            </label>
            <select
              id="payment_method"
              {...register("payment_method", { required: "Payment method is required" })}
              className="mt-1  w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
            >
              {depositMethods?.map((method)=> {
               return (
                <option value={method?.Code}>{method?.Name} </option>
               )

              })}
            </select>
            {errors.payment_method && (
              <p className="mt-1 text-sm text-red-600">{errors.payment_method.message}</p>
            )}
          </div>

          <div>
            <label htmlFor="payment_refno" className=" text-sm font-medium text-gray-700">
              Payment Reference Number
            </label>
            <input
              type="text"
              id="payment_refno"
              {...register("payment_refno", { required: "Payment reference number is required" })}
              className="mt-1  w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
              placeholder="Enter Reference Number"
            />
            {errors.payment_refno && (
              <p className="mt-1 text-sm text-red-600">{errors.payment_refno.message}</p>
            )}
          </div>

          <div>
            <label htmlFor="amount" className=" text-sm font-medium text-gray-700">
              Amount
            </label>
            <input
              type="number"
              id="amount"
              {...register("amount", {
                required: "Amount is required",
                min: { value: 0.01, message: "Amount must be greater than 0" },
                valueAsNumber: true,
              })}
              className="mt-1  w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
              placeholder="Enter Amount"
          
            />
            {errors.amount && (
              <p className="mt-1 text-sm text-red-600">{errors.amount.message}</p>
            )}
          </div>


          <div>
            <label htmlFor="remark" className=" text-sm font-medium text-gray-700">
              Remark
            </label>
            <textarea
              id="remark"
              {...register("remark")}
              className="mt-1  w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50"
              placeholder="Enter any remarks"
              rows="4"
            />
          </div>


      


          <div className="col-span-2 flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring focus:ring-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-500"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPaymentReceivePage;